import TimeAgo from '@cp/src/components/TimeAgo';
import { Typography } from '@navi/web-ui/lib/primitives';
import { ITicketTimeline, TicketAcitvityType } from '../../types';
import styles from './index.module.scss';

const TicketTimeline = (props: ITicketTimeline) => {
  const { activity } = props;
  const { activityAt, activityBy, value } = activity || {};
  const isTicketCreatedView = activity?.type === TicketAcitvityType.TICKET_CREATION;

  return (
    <div className={styles.ticketTimeline}>
      <div className={styles.ticketDetail}>
        <Typography
          variant="p4"
          color="var(--navi-color-gray-c2)"
          className="max-w-[330px] truncate font-medium"
        >
          {isTicketCreatedView ? 'Task created by' : ''} {activityBy?.name}
        </Typography>
        <div className="w-1 h-1 rounded-full bg-[var(--navi-color-gray-c3)]" />
        <TimeAgo
          key={activityAt}
          epoch={activityAt}
          ellipsisClass={styles.ellipsisClass}
          hideTooltipWhenDiffIsOneDay
        />
      </div>
      <Typography variant="p4" color="var(--navi-color-gray-c1)" className={styles.breakWord}>
        {value}
      </Typography>
    </div>
  );
};

export default TicketTimeline;
